import * as React from "react";
import {KatRadiobuttonGroup} from "@amzn/katal-react";
import reviewDecisionStore from "src/app/store/ReviewDecisionStore";
import {v4 as uuid} from "uuid";
import {useEffect, useRef} from "react";
import {RadioButtonGroupInput} from "src/app/model/element/RadioButtonGroupInput";
import {EMPTY_STR} from "src/app/constant/Constants";
import {ElementProps} from "src/app/model/ElementProps";
import {RadioOption} from "src/app/model/RadioOption";

const RadioButtonGroupElement = (props: ElementProps) => {
    const groupName = uuid();
    const inputRef = useRef<any>(null);

    const radioButtonGroup: RadioButtonGroupInput = JSON.parse(props.element.jsonVal);
    const key = radioButtonGroup.key;
    const selected = radioButtonGroup.selected;
    const options: RadioOption[] = [];
    radioButtonGroup.options.map((option, index) => {
            options.push({
                value: option,
                label: option
            })
        }
    );

    useEffect(() => {
        const {auditorInputs} = reviewDecisionStore.value;
        const newAuditorInputs = new Map<string, string>();
        if (auditorInputs != undefined) {
            auditorInputs.forEach((value, key) => {
                newAuditorInputs.set(key, value);
            });
        }
        newAuditorInputs.set(key, EMPTY_STR);
        const newValue = {
            ...reviewDecisionStore.value,
            auditorInputs: newAuditorInputs
        }
        reviewDecisionStore.updateValue(newValue);
    }, []);

    const handleChange = () => {
        const elementId = inputRef.current.id;
        const value = inputRef.current.__value
        const {auditorInputs} = reviewDecisionStore.value;
        const newAuditorInputs = new Map<string, string>();
        if (auditorInputs != undefined) {
            auditorInputs.forEach((value, key) => {
                newAuditorInputs.set(key, value);
            });
        }
        newAuditorInputs.set(elementId, value);
        const newValue = {
            ...reviewDecisionStore.value,
            auditorInputs: newAuditorInputs
        }
        reviewDecisionStore.updateValue(newValue);
    };

    return (
        <div>
            <KatRadiobuttonGroup name={groupName} options={options} value={selected} className='auditor-input'
                                 id={key} onChange={handleChange} ref={inputRef}
                                 data-testid='radio-button-group-element'>
            </KatRadiobuttonGroup>
        </div>
    )
}

export default RadioButtonGroupElement;